import Vue from 'vue';
import moment from 'moment';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import * as echarts from 'echarts';
import Cookies from 'js-cookie';

import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';
import elementTwLocale from 'element-ui/lib/locale/lang/zh-TW';

// import 'element-ui/lib/theme-chalk/index.css'; // elementUI默认主题
import '@/style/element-variables.scss'; // elementUI默认主题
import '@/style/element.scss'; // 全局elementUI样式重置
import '@/style/common.scss'; // 全局通用css
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './utils/axios';
import mixins from './utils/mixins';
import baseMixins from './utils/mixins_base';
import plugin from './utils/plugin';
import directive from './utils/directive';
import Print from './utils/print';
import { i18n } from './locales';

// 合并 ElementUI 语言包
i18n.mergeLocaleMessage('CN', elementZhLocale);
i18n.setLocaleMessage('EN', elementEnLocale);
i18n.setLocaleMessage('TW', elementTwLocale);
Cookies.set('langCode', i18n.locale); // 默认语言

// 打印插件
Vue.use(Print);
// 挂载路由
Vue.use(VueRouter);
// 挂载框架  并且支持国际化
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
// 挂载插件
Vue.use(plugin, store);
// 注册全局mixins.
Vue.mixin(mixins);
Vue.mixin(baseMixins);
Vue.use(directive);
// 挂载axios/echarts
Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.$momentUtc = moment.utc;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
